import includes from 'lodash/includes';
import { setErrorCode, setErrorMessage } from '../slices/errorSlice';

export const SHOW_ERROR_ONLY_CODES = [ 'ERROR_NO_PERMISSION', 'ERROR_INVALID_INIT_JWT', 'ERROR_INVALID_CONTEXT_JWT' ];
export const ACTION_ERROR_CODES = [ 'ERROR_NO_CREDENTIAL' ].concat(SHOW_ERROR_ONLY_CODES);

const shouldIgnoreError = ({ messageConfig, serviceName, code }) => {
  return (messageConfig[serviceName]
    && messageConfig[serviceName].ignoreError
    && messageConfig[serviceName].ignoreError[code])
    || (messageConfig[serviceName]
      && messageConfig[serviceName].notShowDefaultError);
};

const getErrorMessage = ({
  messageConfig, i18n, serviceName, code,
}) => {
  const supportTxt = i18n('checkout.lib.layout.message.defaultErrorMessage.contactSupport');
  const defaultErrorMsg = i18n('checkout.lib.layout.message.defaultErrorMessage', { 0: supportTxt });
  return i18n(messageConfig[serviceName]
    && messageConfig[serviceName].error
    && messageConfig[serviceName].error[code])
    || defaultErrorMsg;
};

export const storeErrors = ({
  error: { contents: { code } }, api, messageConfig, serviceName, errorCallback, i18n,
}) => {
  const ignoreError = shouldIgnoreError({ messageConfig, serviceName, code });
  if (ignoreError) {
    return;
  }
  if (errorCallback) { // for ExpressCheckout and PaymentMethodWidget etc.
    errorCallback({
      msg: getErrorMessage({
        messageConfig, i18n, serviceName, code,
      }),
    });
    return;
  }
  const isActionCode = includes(ACTION_ERROR_CODES, code);
  let message = '';
  if (isActionCode) {
    api.dispatch(setErrorCode(code));
  } else {
    message = (messageConfig[serviceName] && messageConfig[serviceName].error[code])
    || { type: 'danger' };

    if (typeof message === 'string') {
      message = { contents: message };
    }
    if (message && !message.type) {
      message.type = 'danger';
    }
    api.dispatch(setErrorCode(''));
    api.dispatch(setErrorMessage(message));
  }
};

export const resetStoreErrors = (api) => {
  api.dispatch(setErrorCode(''));
  api.dispatch(setErrorMessage(''));
};
